<template>
  <v-dialog persistent fullscreen v-model="show" transition="dialog-bottom-transition">
    <v-card tile>
      <v-card-title class="justify-end px-3 py-2">
        <a @click="closeDialog()" id="btn__LxK4Ezyn7EWp6X+jYGp3fg==">
          <v-icon large>mdi-close</v-icon>
        </a>
      </v-card-title>
      <v-card-subtitle class="pb-0">
        <p class="font--m-4">송금할 거래처 찾기</p>
      </v-card-subtitle>
      <v-card-text>
        <v-autocomplete
          solo
          single-line
          hide-details
          outlined
          flat
          :items="searchWholesalers"
          v-model="wholesaler"
          return-object
          @change="select"
          :loading="searchLoading"
          @update:search-input="search"
          append-icon="search"
          :filter="filterData"
        >
          <template v-slot:selection="{ item }">{{ item.name }}</template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ item.location }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-slot:no-data>
            <v-list-item-content>
              <v-list-item-title class="ma-2">검색 결과가 없습니다</v-list-item-title>
            </v-list-item-content>
            <BasicButton
              id="btn__sDBhE5Toak6BT7oUgNtfhA=="
              color="black"
              :to="{ path: '/wholesaler/form' }"
              >원하는 거래처가 없어요</BasicButton
            >
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-text v-if="payments.results.length > 1">
        <p class="font--m-4" v-if="payments">최근 송금한 거래처</p>
        <div v-for="p in payments.results" :key="p.uuid">
          <a @click="select(p.wholesalerAccount.wholesaler)" id="btn__AR04lAOt00OarNcQrXF1Dg==">
            <p class="font--m-5">{{ p.wholesalerAccount.wholesaler.name }}</p>
            <p class="font--m-7 color--gray-80">
              {{ p.wholesalerAccount.wholesaler.location }}
            </p>
          </a>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      show: true,
      bindProduct: null,
      showWholesalerFinder: false,
      wholesaler: null,
      searchWholesalers: [],
      searchLoading: false,
      searchInterval: null,
    }
  },
  computed: {
    ...mapState('bnpl', ['payments']),
  },
  created() {
    this.getPayments({ page: 1, pageSize: 10 })
  },
  methods: {
    ...mapActions('wholesaler', ['getWholesalers']),
    ...mapActions('bnpl', ['getPayments']),
    closeDialog() {
      this.show = false
      this.$emit('emitClose', false)
    },
    select(v) {
      this.$emit('emitSelect', v)
    },
    filterData(item, q) {
      return item.name.toLowerCase().includes(q.toLowerCase())
    },
    search(search) {
      if (!search || typeof search !== 'string') {
        return
      }
      clearTimeout(this.searchInterval)
      this.searchInterval = setTimeout(async () => {
        try {
          this.searchLoading = true
          this.searchWholesalers = await this.getWholesalers({ search })
        } finally {
          this.searchLoading = false
        }
      }, 300)
    },
  },
}
</script>

<style lang="scss" scoped></style>
